import { RestApiService } from '@frontend/unhideschool/app/api-gateway/services/rest-api.service';
import { UnhDialog } from '@frontend/unhideschool/shared/services/unh-dialog.service';
import { EditorChangeContent } from 'ngx-quill';
// Dependencies
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

// Utils
import { LoggedUserStateService } from '@frontend/unhideschool/core/services/legacy/logged-user.state';
import { CommentModel } from '@frontend/unhideschool/modules/forum/models/comments.model';
import { environment } from '@frontend/unhideschool/env';
import { filter } from 'rxjs/operators';
import { getProfilePicture } from '@frontend/unhideschool/app/helpers/relatedmedia-and-crop.helper';

@Component({
  selector: 'unh-comment-item',
  templateUrl: './comment-item.component.html',
  styleUrls: ['./comment-item.component.scss'],
})
export class CommentItemComponent implements OnInit {
  @Input() comment: CommentModel;
  @Input() isreply = false;

  @Output() replySubmitted = new EventEmitter<{ commentid: string, value: string }>();
  @Output() likeClicked = new EventEmitter<{ commentid: string, liked: boolean }>();
  @Output() removeComment = new EventEmitter<{ commentid: string, text: string }>();
  @Output() editComment = new EventEmitter<{ commentid: string, text: string, relatedmedia?: any, newimages?: any; }>();

  commentMessageBeforeEdit = null;

  commentMessage = null;
  replyOpen = false;
  editMode = false;

  defaultAvatarUrl = environment.defaultAvatarUrl;
  quillEditor;
  commentImages: any;
  submitDisabled: boolean;

  isAuthor: boolean;

  userAvatarUrl = '';

  constructor(
    public luss: LoggedUserStateService,
    private unhd: UnhDialog,
    private capis: RestApiService
  ) { }

  ngOnInit(): void {
    this.isAuthor = this.luss.user?.uid === Number(this.comment.authoruid);

    this.userAvatarUrl = (
      this.comment.avatar
        ? getProfilePicture(this.comment.avatar, this.comment.userrelatedmedia)
        : this.defaultAvatarUrl
    );
  }

  toggleReply() {
    this.replyOpen = !this.replyOpen;
  }

  toggleLike() {
    this.likeClicked.emit({ commentid: this.comment.commentid, liked: !this.comment.userliked });
  }

  onReplySubmitted(value: string) {
    this.replyOpen = false;
    this.replySubmitted.emit({ commentid: this.comment.commentid, value });
  }

  handleRemoveComment() {
    this.unhd.confirm({
      text: {
        title: 'Você está deletando\n seu comentário.',
        // message: 'Deseja mesmo fazer isso?'
      }

    }).subscribe(result => {
      if (result) {
        this.removeComment.emit({ commentid: this.comment.commentid, text: this.comment.message });

      }
    });
  }

  editInPlace() {
    this.editMode = !this.editMode;
    this.commentMessageBeforeEdit = this.quillEditor.root.innerHTML;

  }

  handleEditComment() {
    const uploadedImages = [];
    let count = 0;
    this.editMode = !this.editMode;

    if (this.commentImages.length > 0) {
      this.commentImages.forEach(image => {
        const data = new FormData();
        data.append('file', image.file, image.file.name);
        data.append('mediacontenttype', 'communitymediaitem');
        this.capis.upload('/media/uploadfile', data).pipe(
          filter(res => res != null)
        ).subscribe(res => {
          if (res.success) {
            count++;
            const uploadedImage = {
              id: res.message.fileid,
              url: res.message.urlimage
            }
            uploadedImages.push(uploadedImage)
            this.commentMessage = this.commentMessage.replace(image.blobUrl, uploadedImage.url);
            if (count == this.commentImages.length) {
              this.editComment.emit({ commentid: this.comment.commentid, text: this.commentMessage, relatedmedia: this.comment.relatedmedia, newimages: uploadedImages });
              this.commentMessage = null;

            }
          }

        })
      })
    }
    else {
      this.editComment.emit({ commentid: this.comment.commentid, text: this.commentMessage, relatedmedia: this.comment.relatedmedia });
      this.commentMessage = null;

    }

  }
  initCommentContent(e, message) {
    this.quillEditor = e;
    if (message) {
      this.quillEditor.pasteHTML(message);
    }
  }
  onMessageChanged(e: EditorChangeContent) {
    if (e.event === 'text-change') {
      if (this.editMode) {
        this.commentMessage = e.html;
        if (this.commentImages.length == 0 && this.commentMessage == null) {
          this.submitDisabled = true;
        } else {
          this.submitDisabled = false;
        }
      }
    }
  }

  onImagesChanged(images) {
    this.commentImages = images;
  }

  cancelEdit() {
    this.quillEditor.root.innerHTML = this.commentMessageBeforeEdit;
    this.editMode = !this.editMode;
  }
}
